export default __webpack_public_path__ + "static/media/KEBAB.d22ef823.png";